import React from "react";
import {
  StyledDescriptionDiv,
  StyledHeaderContainerDiv,
  StyledHeaderDiv,
  StyledSectionContainerDiv,
} from "../index.styles";
import { Pagination } from "antd";
import styled from "styled-components";
import { ProductCard } from "../components/ProductCard";
import { B2bFooter } from "../../components/layout/footer";

import { CatalogueGridSkeleton } from "../components/skeleton";

// Main CatalogueSection Component
export const CatalogueSection = ({
  products = [],
  count = 0,
  isLoading = false,
  page = 1,
  pageSize = 10,
  onPaginationChange,
  onAddToCart,
  addingProductId,
}) => {
  return (
    <>
      <StyledSectionContainerDiv>
        <StyledHeaderContainerDiv style={{ marginBottom: "24px" }}>
          <StyledHeaderDiv>Catalogue</StyledHeaderDiv>
          <StyledDescriptionDiv>Prices shown reflect your contract</StyledDescriptionDiv>
        </StyledHeaderContainerDiv>

        {/* Products Grid / Loading state / Empty state */}
        {isLoading ? (
          <CatalogueGridSkeleton cardsCount={pageSize} />
        ) : products.length > 0 ? (
          <ProductsGrid>
            {products.map(product => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={onAddToCart}
                isAddingToCart={addingProductId === product.id}
              />
            ))}
          </ProductsGrid>
        ) : (
          <div
            style={{ padding: "80px 0", textAlign: "center", fontSize: "16px", color: "#686978" }}
          >
            No products found matching the criteria.
          </div>
        )}

        {/* Custom styled Pagination Footer */}
        {count > 0 && (
          <PaginationWrapper>
            <Pagination
              current={page}
              total={count}
              showSizeChanger
              showQuickJumper
              pageSize={pageSize}
              onChange={onPaginationChange}
              showTotal={(total, range) => `Results ${range[0]}-${range[1]} of ${total}`}
              locale={{
                jump_to: "Go to",
                page: "Page",
              }}
            />
          </PaginationWrapper>
        )}
      </StyledSectionContainerDiv>

      {/* Footer */}
      <B2bFooter />
    </>
  );
};

// Styled Components
const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PaginationWrapper = styled.div`
  margin-top: auto;
  padding: 10px 0;
  width: 100%;
  background-color: #fff;

  .ant-pagination {
    color: var(--GREY, #4a4a68);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0.36px;

    .ant-pagination-item,
    .ant-pagination-options-quick-jumper,
    .ant-select-selection-item,
    .ant-select-item-option-content {
      color: var(--GREY, #4a4a68);
      text-align: center;
      font-family: Inter;
      font-feature-settings:
        "liga" off,
        "clig" off;
      font-size: 14px;
      font-weight: 600;
    }

    .ant-select-selector {
      cursor: pointer;
    }

    .ant-pagination-item-active {
      border-color: transparent;
      color: var(--Primary-Blue, #2060ea);
    }
  }

  .ant-pagination {
    position: relative;
    display: flex;
    justify-content: flex-end;

    .ant-pagination-total-text {
      position: absolute;
      left: 0;
    }
  }
`;
